export const TOGGLE_DASHBOARD_LOADING = 'TOGGLE_DASHBOARD_LOADING'

export const toggleDashboardLoading = (on) => ({
  type: TOGGLE_DASHBOARD_LOADING,
  on,
})
